import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import TopMenuAgenticEUC from "./components/TopMenu/TopMenuAgenticEUC";
import { Outlet } from "react-router-dom";
import { ColorModeContext, useMode} from "../../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import "./AgenticEUCStyle.css";
import "../../styles/moduleBackgrounds.css"; 
import AgenticEUCDashboard from "./pages/Dashboard/AgenticEUCDashboard";


function AgenticEUCApp() {
    const [theme, colorMode] = useMode();
  const [role, setRole] = useState(null);
  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  });


  return (
     <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="module-agenticeuc">
          <main className="contente height100">
            <TopMenuAgenticEUC />
            <Routes>
             <Route path="/" element={<AgenticEUCDashboard />} />
           </Routes>
            <Outlet />
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  )
} 

export default AgenticEUCApp
